import { localAccountColumnDefinition, localAccountDescriptionColumnDefinition, r2rAccountColumnDefinition, r2rDescriptionColumnDefinition } from '../columnDefinitions';

export default [
  {
    ...localAccountColumnDefinition,
    headerName: 'Local Account',
  },
  {
    ...localAccountDescriptionColumnDefinition,
    headerName: 'Local Account Description',
  },
  r2rAccountColumnDefinition,
  {
    ...r2rDescriptionColumnDefinition,
    headerName: 'Account Description',
  },
];
